// extracted by mini-css-extract-plugin
export default {"container":"GoalInformation_container__Cm1kw","warning":"GoalInformation_warning__xpacd"};